import React, { useState } from "react";
import ImageModal from "../components/common/ImageModal";

const Products = () => {
  const [filterKey, setFilterKey] = useState("*");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState("");

  const filters = {
    CHIMNEY: "chimney",
    GAS: "gas",
  };

  const products = [
    {
      img: "img/products/001.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/002.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/003.webp",
      category: filters.GAS,
    },
    {
      img: "img/products/004.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/005.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/006.webp",
      category: filters.GAS,
    },
    {
      img: "img/products/007.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/008.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/009.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/010.webp",
      category: filters.CHIMNEY,
    },
    {
      img: "img/products/011.webp",
      category: filters.CHIMNEY,
    },
  ];

  // Filter products based on selected category
  const filteredProducts =
    filterKey === "*"
      ? products
      : products.filter((product) => product.category === filterKey);

  const handleFilterKeyChange = (key) => setFilterKey(key);

  // Debug modal state
  console.log("Modal state:", { isModalOpen, imgSrc });

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              <span className="text-orange-400">Premium</span> Products
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
              Discover our exclusive range of high-quality kitchen appliances
              designed to transform your cooking experience.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Electric Chimneys
                </h3>
                <p className="text-lg">Advanced smoke extraction technology</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Gas Stoves
                </h3>
                <p className="text-lg">Professional cooking performance</p>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-lg p-6 border border-orange-300">
                <h3 className="text-2xl font-bold mb-2 text-orange-300">
                  Modern Design
                </h3>
                <p className="text-lg">Sleek aesthetics for your kitchen</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Product Categories Section */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
              Product Categories
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Browse through our comprehensive collection of kitchen appliances
              and find the perfect fit for your home.
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <button
              className={`px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 ${
                filterKey === "*"
                  ? "bg-indigo-600 text-white shadow-lg"
                  : "bg-indigo-100 text-indigo-600 hover:bg-indigo-200"
              }`}
              onClick={() => handleFilterKeyChange("*")}
            >
              All Products
            </button>
            <button
              className={`px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 ${
                filterKey === filters.CHIMNEY
                  ? "bg-indigo-600 text-white shadow-lg"
                  : "bg-indigo-100 text-indigo-600 hover:bg-indigo-200"
              }`}
              onClick={() => handleFilterKeyChange(filters.CHIMNEY)}
            >
              Electric Chimneys
            </button>
            <button
              className={`px-8 py-4 rounded-xl font-semibold text-lg transition-all duration-300 transform hover:scale-105 ${
                filterKey === filters.GAS
                  ? "bg-indigo-600 text-white shadow-lg"
                  : "bg-indigo-100 text-indigo-600 hover:bg-indigo-200"
              }`}
              onClick={() => handleFilterKeyChange(filters.GAS)}
            >
              Gas Stoves
            </button>
          </div>

          {/* Product Gallery */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredProducts.map((product, index) => (
              <div
                key={`${product.category}-${index}`}
                className="transform hover:scale-105 transition-all duration-500 ease-in-out cursor-pointer animate-fadeIn"
                onClick={() => {
                  setImgSrc(product.img);
                  setIsModalOpen(true);
                  console.log("Image clicked:", product.img);
                }}
                style={{
                  animationDelay: `${index * 100}ms`,
                  animationFillMode: "both",
                }}
              >
                <img
                  className="w-full h-auto max-h-80 object-contain rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
                  src={product.img}
                  alt="Product"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Catalog Section */}
      <div className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
              Product Catalog
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Download our comprehensive product catalog to explore our full
              range of kitchen appliances and specifications.
            </p>
          </div>

          <div className="w-full">
            <div className="bg-white rounded-2xl shadow-xl p-4 md:p-8 lg:p-12">
              <div className="text-center">
                <img
                  className="w-full mb-8 shadow-lg"
                  src={"img/products/catlog.png"}
                  alt="Product Catalog"
                />
                <h3 className="text-2xl font-bold text-gray-800 mb-4">
                  Complete Product Catalog
                </h3>
                <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
                  Get detailed information about all our products including
                  specifications, features, and pricing. Our catalog is
                  regularly updated with the latest models and innovations.
                </p>
                <a
                  className="inline-flex items-center px-8 py-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-lg transition-colors duration-300 transform hover:scale-105"
                  href="docs/catlog.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    className="w-5 h-5 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  Download Catalog
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <div className="z-50">
          <ImageModal src={imgSrc} setIsModalOpen={setIsModalOpen} />
        </div>
      )}
    </div>
  );
};

export default Products;
